import { render, staticRenderFns } from "./ConfigActionsModal.vue?vue&type=template&id=4e166dca&scoped=true&"
import script from "./ConfigActionsModal.vue?vue&type=script&lang=js&"
export * from "./ConfigActionsModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfigActionsModal.vue?vue&type=style&index=0&id=4e166dca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e166dca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e166dca')) {
      api.createRecord('4e166dca', component.options)
    } else {
      api.reload('4e166dca', component.options)
    }
    module.hot.accept("./ConfigActionsModal.vue?vue&type=template&id=4e166dca&scoped=true&", function () {
      api.rerender('4e166dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/ConfigActionsModal.vue"
export default component.exports